<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";

import commonTable2 from "../../table/vue-good-table/commonTableModal.vue";
import SearchFilter from "./components/SearchFilter.vue";

import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";

import * as officerStore from "@/store/api/officer/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    commonTable2,
    SearchFilter,
    BOverlay,
  },
  data() {
    return {
      tabs: [
        { title: "รายการเรื่องร้องทุกข์", mode: "Province" },
        { title: "ประวัติดำเนินการ", mode: "UserHistory" },
      ],
      activeTab: ["Province"],
      modalName: "my-modal",
      notificationComplaints: [],
      tableHeader: commonTableHeader,
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    getComplaintNotification() {
      const _this = this;
      officerStore
        .getComplaintForNoti(userData.departmentId(), userData.userId())
        .then((response) => {
          console.log("data", response.data.data);
          if (response.data.data.totalresult > 0) {
            // show data
            _this.notificationComplaints = response.data.data.listForNewcase;

            _this.$refs.ModalNotification.$refs["modal-notification"].show();
          }
          //_this.$refs.ModalNotification.$refs["modal-notification"].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageGroup(id) {
      if (this.activeTab[0] == "UserHistory") {
        const routeData = this.$router.resolve({
          name: "ComplaintHistoryDetail",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        const routeData = this.$router.resolve({
          name: "ProvincialOfficerManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    searchFilterSubmit(params) {
      // if (this.$route.query.id == null) {
      //   params.userActive = userData.userId();
      // } else {
      //   params.userActive = this.$route.query.id;
      // }

      params.departmentId = appsettings.provinceDepartmentId;

      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnClosePopup() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    onBtnReceive() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "servicecentercomplaint",
          query: { parentComponent: "Officer" },
        }).href,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
